import type { ReactElement } from 'react'
import styled from 'styled-components'

import { IR_INVESTOR_ROUTE } from '@/utils/routes'

import { ShareholderContent } from './ShareholderContent'
import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Footer } from '@/components/layouts/Ir/Footer'
import { AHeading } from '@/components/layouts/Ir/Heading'

const newRoute = IR_INVESTOR_ROUTE.subdirectories
const topLinks = [newRoute[0], newRoute[1], newRoute[2], newRoute[3], newRoute[4], newRoute[8]]
const shareholderLink = IR_INVESTOR_ROUTE.subdirectories[5]
const bottomLinks = IR_INVESTOR_ROUTE.subdirectories.slice(5, 7)

export const InvestorPage = () => {
  return (
    <div>
      <TopContainer>
        <SectionTitle
          titleText="To Retail Investor"
          subTitleText="個人投資家の皆様へ"
          color="normal"
        />
        <Spacer h={{ sp: 70, pc: 120 }} />
        <AHeading>株主通信（TRIAL レポート）</AHeading>
        <Spacer h={{ sp: 20, pc: 40 }} />
        <LinkCardList>
          {topLinks.map(({ path, name, imagePath, ...rest }) => (
            <LinkCard
              link={path}
              title={name}
              imgPath={imagePath}
              {...rest}
              key={path}
            />
          ))}
        </LinkCardList>
      </TopContainer>
      <Spacer h={{ sp: 31, pc: 68 }} />
      <ShareholderContent {...shareholderLink} />
      <Spacer h={{ sp: 70, pc: 104 }} />
      <BottomContainer>
        <LinkCardList>
          {bottomLinks.map(({ path, name, imagePath, ...rest }) => (
            <LinkCard
              link={path}
              title={name}
              imgPath={imagePath}
              {...rest}
              key={path}
            />
          ))}
        </LinkCardList>
        <LinkCardDiv><a href="https://sharedresearch.jp/ja/companies/141A" target="_blank" rel="noopener noreferrer"><img src="/images/shared_research_ja.png" /></a></LinkCardDiv>
        <Spacer h={{ sp: 70, pc: 140 }} />
        <Footer />
      </BottomContainer>
    </div>
  )
}

InvestorPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '個人投資家の皆様へ', path: '' },
  ]

  return (
    <>
      <Head
        title="個人投資家の皆様へ"
        description="トライアルホールディングスの個人投資家様向けの情報を掲載しています。"
        ogp={{ url: 'ir/investor/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const TopContainer = styled.div`
  width: 1040px;
  margin: 94px auto 0;

  @media screen and (max-width: 1047px) {
    margin: 40px auto 0;
    width: 100%;
    padding: 0 20px;
  }
`

const BottomContainer = styled.div`
  width: 1040px;
  margin: 0 auto 130px;

  @media screen and (max-width: 1047px) {
    margin: 0 auto 120px;
    width: 100%;
    padding: 0 20px;
  }
`

const LinkCardDiv = styled.div`
  width: 316px;
  img {
    width: 316px;
    border: 4px solid #e5f5fc;
    border-radius: 8px;
    margin-top: 46px;
    display: block;
  }

  @media screen and (max-width: 1047px) {
    width: 335px;
    margin: 0 auto;
    img {
      margin: 22px auto 0;
      width: 335px;
    }
  }
`